import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserSettingState } from './usersetting.state';
import { userFeatureKey } from './usersetting.reducers';

export const selectUserSettingState = createFeatureSelector<UserSettingState>(userFeatureKey);

export const selectUserSetting = createSelector(selectUserSettingState, (state: UserSettingState) => {
    return state
});